var map = {
	"./BGMain.jpg": "01f0",
	"./BGMain10.jpg": "7326",
	"./BGMain11.jpg": "a91b",
	"./BGMain2.jpg": "5517",
	"./BGMain3.jpg": "0534",
	"./BGMain4.jpg": "19af",
	"./BGMain5.jpg": "e2fd",
	"./BGMain6.jpg": "3dc6",
	"./BGMain8.jpg": "6330",
	"./BGMain9.jpg": "e84c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8311";